import React, { useEffect, useRef, useState } from "react";
import { Outlet } from "react-router-dom";
import { useSelector } from "react-redux";
import { getPageRoute, getPageTitle } from "../../store/layoutUI";
import LeftMenu from "../../../components/Menu";
import RecruitmentMenu from "../../../components/WorkplaceMenus/RecruitmentMenu";
import OnboardingMenu from "../../../components/WorkplaceMenus/OnboardingMenu";
import SafetyManagementMenu from "../../../components/WorkplaceMenus/SafetyManagementMenu";
import TopMenu from "../../components/Header/TopMenu";
import Breadcrumb from "./Bredcrumb";
import WcagPopup from "../../../Wcag/WcagPopup";
import OnScreenKeyBoard from "../../../Wcag/OnScreenKeyBoard";
import Keyboard from "react-simple-keyboard";
import "react-simple-keyboard/build/css/index.css";

const Layout = () => {
  const [scriptLoadingState, setScriptLoadingState] = useState("IDLE");
  const [wcagShowHide, setWcagShowHide] = useState(false);
  const [smartNav, setSmartNav] = useState(false);
  const [keyboardShowHide, setKeyboardShowHide] = useState(false);
  const [input, setInput] = useState("");
  const [layout, setLayout] = useState("default");
  const [tabOpenStatus, setTabOpenStatus] = useState(false);
  const [isMenuCollapsed, setIsMenuCollapsed] = useState(true);
  const [headerVisible, setHeaderVisible] = useState(true);
  const keyboard = useRef();

  const showCollapsedRail = !isMenuCollapsed;

  useEffect(() => {
    var script = document.createElement("script");
    script.async = true;
    script.type = "text/javascript";
    script.src = "/assets/js/argon.js";
    script.onload = function () {
      setScriptLoadingState("LOADED");
    };
    script.onerror = function () {
      setScriptLoadingState("FAILED");
    };
    document.body.appendChild(script);
  }, []);

  const handleWcagModalShowHide = () => {
    setWcagShowHide((prev) => !prev);
  };

  const handleModalShowHide = () => { };

  const handleNavigation = () => {
    handleModalShowHide();
    setSmartNav((prev) => !prev);
  };

  const getVirtualKeyBoard = () => {
    const vr = document.body.classList.contains("INDvirtualKeyboard");
    if (vr) return "block";
    return "none";
  };

  const handleKeyboardShowHide = () => {
    setKeyboardShowHide(!keyboardShowHide);
  };

  const onChange = (input) => {
    setInput(input);
    console.log("Input changed", input);
  };

  const handleShift = () => {
    const newLayoutName = layout === "default" ? "shift" : "default";
    setLayout(newLayoutName);
  };

  const onKeyPress = (button) => {
    console.log("Button pressed", button);

    /**
     * If you want to handle the shift and caps lock buttons
     */
    if (button === "{shift}" || button === "{lock}") handleShift();
  };

  const onChangeInput = (event) => {
    const input = event.target.value;
    setInput(input);
    keyboard.current.setInput(input);
  };

  const toggleMenu = (val) => {
    // console.log("val", val)
    setTabOpenStatus(val);
  };

  const renderSideMenu = () => {
    const selectedWorkplace = localStorage.getItem("selectedWorkplace");

    const menuProps = {
      isCollapsed: showCollapsedRail,
      onToggleCollapse: () => setIsMenuCollapsed((prev) => !prev),
      onClickToggle: toggleMenu,
    };

    switch (selectedWorkplace) {
      case "recruitment":
        return <RecruitmentMenu {...menuProps} />;
      case "onboarding":
        return <OnboardingMenu {...menuProps} />;
      case "safety":
        return <SafetyManagementMenu {...menuProps} />;
      default:
        return <LeftMenu {...menuProps} />;
    }
  };

  return (
    <>
      <style>{`
            body, html {
                overflow: hidden !important;
                height: 100vh !important;
                margin: 0 !important;
                padding: 0 !important;
            }
            #sidenav-main {
                width: ${showCollapsedRail ? 120 : 280}px !important;
                height: calc(100vh - ${headerVisible ? 200 : 106}px) !important;
                position: fixed !important;
                top: ${headerVisible ? 215 : 106}px !important;
                left: 0 !important;
                z-index: 1020 !important;
                overflow: hidden !important;
                overflow-y: hidden !important;
                transform: none !important;
                transition: width 0.2s cubic-bezier(0.4, 0, 0.2, 1), top 0.2s ease, height 0.2s ease;
            }
            #sidenav-main::-webkit-scrollbar {
                display: none !important;
                width: 0 !important;
                height: 0 !important;
            }
            .main-content {
                padding-left: ${showCollapsedRail ? 120 : 280}px !important;
                transition: padding-left 0.2s cubic-bezier(0.4, 0, 0.2, 1);
                margin-left: 0 !important;
                max-width: 100%;
            }
            @keyframes contentFadeIn {
                from {
                    opacity: 0;
                    transform: translateY(12px);
                }
                to {
                    opacity: 1;
                    transform: translateY(0);
                }
            }
            #layout-scroll-wrapper {
                height: calc(100vh - ${headerVisible ? 215 : 106}px) !important;
                overflow-y: auto !important;
                overflow-x: hidden !important;
                background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%) !important;
                scroll-behavior: smooth !important;
                animation: contentFadeIn 0.5s cubic-bezier(0.16, 1, 0.3, 1) both !important;
                padding-bottom: 0px !important;
            }
            .layout-content-area {
                padding-left: 14px !important;
                padding-right: 14px !important;
                padding-bottom: 14px !important;
                display: flex !important;
                flex-direction: column !important;
                min-height: 100% !important;
                box-sizing: border-box !important;
            }
            .layout-content-area > .container-fluid,
            .layout-content-area .container-fluid {
                padding-left: 0 !important;
                padding-right: 0 !important;
            }
            .layout-content-area > .col-md-12,
            .layout-content-area > div > .col-md-12 {
                padding-left: 0 !important;
                padding-right: 0 !important;
            }
            .layout-sticky-breadcrumb {
                // position: sticky !important;
                top: 0 !important;
                z-index: 1015 !important;
                padding-top: 1px !important;
            }
            /* Premium Scrollbar */
            #layout-scroll-wrapper::-webkit-scrollbar {
                width: 5px !important;
                height: 5px !important;
            }
            #layout-scroll-wrapper::-webkit-scrollbar-track {
                background: transparent !important;
            }
            #layout-scroll-wrapper::-webkit-scrollbar-thumb {
                background: linear-gradient(180deg, #94a3b8, #cbd5e1) !important;
                border-radius: 20px !important;
                transition: all 0.2s ease !important;
            }
            #layout-scroll-wrapper::-webkit-scrollbar-thumb:hover {
                background: linear-gradient(180deg, #64748b, #94a3b8) !important;
            }
        `}</style>

      <div className="w-100 p-0" style={{ position: "relative", zIndex: 1030 }}>
        <TopMenu
          headerVisible={headerVisible}
          setHeaderVisible={setHeaderVisible}
        />
      </div>

      {renderSideMenu()}

      <div className="main-content h-100" id="panel">
        <div id="layout-scroll-wrapper">
          {/* <h1 className="visually-hidden">{input || "Application"}</h1> */}
          {/* <div
                    style={{
                        position: "fixed",
                        right: "-5%",
                        top: "92%",
                        zIndex: "99",
                        cursor: "pointer",
                    }}
                >
                    <img
                        onClick={handleWcagModalShowHide}
                        src="/assets/img/wcagIcon.png"
                        alt="Web Content Accessibility Guidelines Image Button"
                        className="btn w-25 p-1 btn-sm btn-default"
                        title="Web Content Accessibility Guidelines (WCAG)"
                    />
                </div> */}

          {!tabOpenStatus && (
            <div className="layout-content-area">
              <div className="layout-sticky-breadcrumb">
                <Breadcrumb />
              </div>
              <Outlet />
            </div>
          )}
        </div>
      </div>
      <WcagPopup
        showHide={wcagShowHide}
        handleModalShowHide={handleWcagModalShowHide}
        handleNavigation={handleNavigation}
      ></WcagPopup>

      <OnScreenKeyBoard
        keyboardShowHide={keyboardShowHide}
        handleKeyboardShowHide={handleKeyboardShowHide}
      ></OnScreenKeyBoard>

      <div
        style={{
          display: `${getVirtualKeyBoard()}`,
          position: "fixed",
          bottom: "0px",
          boxShadow: "#c8c8c8 0px 0px 15px 5px",
          border: "20px solid #000000",
          zIndex: "9999",
          width: "100%",
        }}
      >
        <input
          value={input}
          placeholder={"Tap on the virtual keyboard to start"}
          onChange={onChangeInput}
          className="form-control"
          aria-label="Tap on the virtual keyboard to start"
        />
        <Keyboard
          keyboardRef={(r) => (keyboard.current = r)}
          layoutName={layout}
          onChange={onChange}
          onKeyPress={onKeyPress}
        />
      </div>
    </>
  );
};

export default Layout;
